module.exports = __webpack_public_path__ + "img/ChampionLA-Solicitation Package_p1.9b84bf94.jpg";